'use client';

import type * as React from 'react';

import * as HoverCardPrimitive from '@radix-ui/react-hover-card';
import { twMerge } from 'tailwind-merge';

import { cs } from '@/_shared';

const HoverCard = HoverCardPrimitive.Root;

const HoverCardTrigger = HoverCardPrimitive.Trigger;

const HoverCardContent = ({
  ref,
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Content> & {
  ref?: React.RefObject<React.ElementRef<typeof HoverCardPrimitive.Content> | null>;
}) => (
  <HoverCardPrimitive.Content
    ref={ref}
    align={align}
    sideOffset={sideOffset}
    className={twMerge(
      'border-c-border text-c-card-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-64 border bg-white p-4 shadow-lg shadow-gray-500/10 outline-hidden dark:bg-gray-950 dark:shadow-gray-800/50',
      'rounded-3xl',
      cs('rounded-[2.7rem]'),
      className
    )}
    {...props}
  />
);

const HoverCardContentWithPortal = ({
  ref,
  className,
  align = 'center',
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof HoverCardPrimitive.Content> & {
  ref?: React.RefObject<React.ElementRef<typeof HoverCardPrimitive.Content> | null>;
}) => (
  <HoverCardPrimitive.Portal>
    <HoverCardPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={twMerge(
        'border-c-border text-accent data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-64 border bg-white p-4 shadow-lg shadow-gray-500/10 outline-hidden dark:bg-gray-950 dark:text-gray-400 dark:shadow-gray-800/50',
        'rounded-3xl',
        cs('rounded-[2.7rem]'),
        className
      )}
      {...props}
    />
  </HoverCardPrimitive.Portal>
);

export { HoverCard, HoverCardContent, HoverCardContentWithPortal, HoverCardTrigger };
